export default {
  addItem: {
    position: 'absolute',
    right: 200,
    top: 35,
    zIndex: 1,
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  stages: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 5,
  },
};



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/JobProfilesGrid/styles.js